var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen.lock",
          value: _vm.loading,
          expression: "loading",
          modifiers: { fullscreen: true, lock: true },
        },
      ],
      staticClass: "clearfix main_center",
    },
    [
      _c("div", { staticClass: "top-content" }, [
        _c(
          "div",
          { staticClass: "left-navbar" },
          [
            _c(
              "el-button",
              {
                attrs: { size: "small" },
                on: {
                  click: function ($event) {
                    return _vm.back("project_extract_list")
                  },
                },
              },
              [_vm._v("返回")]
            ),
            _c(
              "el-button",
              {
                attrs: { type: "primary", plain: "", size: "small" },
                on: {
                  click: function ($event) {
                    return _vm.back("resultNotice_detail", {
                      id: _vm.form.id,
                      flag: 1,
                    })
                  },
                },
              },
              [_vm._v("发布检查结果公告")]
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "right-content clearfix" },
        [
          _c(
            "el-form",
            {
              staticClass: "form viewFormWrapper",
              attrs: { "label-width": "180px" },
            },
            [
              _c(
                "el-card",
                { staticClass: "box-card" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "clearfix",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [_c("span", [_vm._v("抽取基本信息")])]
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 15 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "任务名称：" } },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.form.workName || "-") + " "),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 15 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "抽取编号：" } },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.form.extractCode || "-")),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "抽取类型：" } },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.form.extractTypeName || "-")),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 15 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "监督检查单位：" } },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.form.supervisionIdsName || "-")
                                ),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 15 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "抽取完成时间：" } },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.form.extractTime || "-")),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "抽取人员：" } },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.form.extractorName || "-")),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-card",
                { staticClass: "box-card" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "clearfix",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [_c("span", [_vm._v("项目随机抽取规则")])]
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                label: "项目所属监管单位：",
                                prop: "superviseDeptCode",
                              },
                            },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.form.superviseDeptCodeName)),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                label: "项目名称包含：",
                                prop: "projectName",
                              },
                            },
                            [_c("span", [_vm._v(_vm._s(_vm.form.projectName))])]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                label: "项目招标人名称包含：",
                                prop: "tendererName",
                              },
                            },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.form.tendererName || "-")),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                label: "项目招标代理名称包含：",
                                prop: "tenderAgencyName",
                              },
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.form.tenderAgencyName || "-")
                                ),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                label: "招标公告发布时间：",
                                prop: "datetimerange",
                              },
                            },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.form.noticePubTimes || "-")),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                label: "项目合同签署时间：",
                                prop: "datetimerange1",
                              },
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.form.contractSignTimes || "-")
                                ),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                label: "抽取数量组成方式：",
                                prop: "ruleType",
                              },
                            },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  attrs: { disabled: "" },
                                  model: {
                                    value: _vm.form.ruleType,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "ruleType", $$v)
                                    },
                                    expression: "form.ruleType",
                                  },
                                },
                                [
                                  _c("el-radio", { attrs: { label: 1 } }, [
                                    _vm._v("数量"),
                                  ]),
                                  _c("el-radio", { attrs: { label: 2 } }, [
                                    _vm._v("百分比"),
                                  ]),
                                  _c("el-radio", { attrs: { label: 3 } }, [
                                    _vm._v("复合方式"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.form.ruleType == 1 || _vm.form.ruleType == 2
                        ? _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    label: "抽取数量：",
                                    prop: "extractRule",
                                  },
                                },
                                [
                                  _c("span", [
                                    _vm._v("从符合条件的总数中随机抽取"),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.form.extractRule +
                                          " " +
                                          (_vm.form.ruleType == 1 ? "个" : " %")
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.form.ruleType == 3
                        ? _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    label: "项目抽取条件：",
                                    prop: "extractRule",
                                  },
                                },
                                [
                                  _c("table", { staticClass: "role_table" }, [
                                    _c(
                                      "thead",
                                      { staticStyle: { width: "100%" } },
                                      [
                                        _c("th", { attrs: { width: "50%" } }, [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.formatterDataDictionary(
                                                  _vm.extractNumberTypeList,
                                                  _vm.form.ruleCompMethod
                                                )
                                              )
                                            ),
                                          ]),
                                        ]),
                                        _c("th", { attrs: { width: "50%" } }, [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.form.numOrPercentType == "1"
                                                  ? "数量"
                                                  : "比例"
                                              )
                                            ),
                                          ]),
                                        ]),
                                      ]
                                    ),
                                    _c(
                                      "tbody",
                                      _vm._l(
                                        _vm.ruleList,
                                        function (item, index) {
                                          return _c("tr", { key: index }, [
                                            _c("td", [
                                              _vm.form.ruleCompMethod == "1"
                                                ? _c("p", [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.projectTypeName
                                                        )
                                                      ),
                                                    ]),
                                                  ])
                                                : _vm.form.ruleCompMethod == "2"
                                                ? _c("p", [
                                                    _vm._v(" 介于 "),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(item.currencyMin)
                                                      ),
                                                    ]),
                                                    _vm._v("万元 至 "),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(item.currencyMax)
                                                      ),
                                                    ]),
                                                    _vm._v(" 万元 "),
                                                  ])
                                                : _c("p", [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.regionCodeName
                                                        )
                                                      ),
                                                    ]),
                                                  ]),
                                            ]),
                                            _c("td", [
                                              _vm._v(" 符合抽取条件总项目的 "),
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(item.numOrPercent)
                                                ),
                                              ]),
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.form.numOrPercentType ==
                                                      "1"
                                                      ? "个"
                                                      : "%"
                                                  )
                                                ),
                                              ]),
                                            ]),
                                          ])
                                        }
                                      ),
                                      0
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-card",
                { staticClass: "box-card" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "clearfix",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [_c("span", [_vm._v("执法检查人员抽取规则")])]
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                label: "本次执法人员：",
                                prop: "extractPondPersonList",
                              },
                            },
                            [
                              _c("p", { staticStyle: { margin: "0" } }, [
                                _vm._v("共计 "),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.extractPondPersonList.length)
                                  ),
                                ]),
                                _vm._v("名"),
                              ]),
                              _vm._l(
                                _vm.extractPondPersonList,
                                function (item, index) {
                                  return _c(
                                    "span",
                                    {
                                      key: index,
                                      staticStyle: { margin: "0" },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          item.personName +
                                            (item.personDesc
                                              ? "（" + item.personDesc + "）"
                                              : "")
                                        ) + "；"
                                      ),
                                    ]
                                  )
                                }
                              ),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                label: "执法人员分组：",
                                prop: "groupNum",
                              },
                            },
                            [
                              _vm._v(" 共分为"),
                              _c("span", [_vm._v(_vm._s(_vm.form.groupNum))]),
                              _vm._v("个小组 "),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-card",
                { staticClass: "box-card" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "clearfix",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [_c("span", [_vm._v("项目双随机匹配结果")])]
                  ),
                  _c("div", [
                    _c("div", { staticClass: "titleBox" }, [
                      _c("h3", { staticClass: "twoTitle" }, [
                        _vm._v("双随机抽取结果表"),
                      ]),
                      _c(
                        "div",
                        { staticClass: "noticeBtn" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text" },
                              on: {
                                click: function ($event) {
                                  return _vm.resultNoticeFn("2")
                                },
                              },
                            },
                            [_vm._v("通知执法检查人员")]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text" },
                              on: {
                                click: function ($event) {
                                  return _vm.resultNoticeFn("1")
                                },
                              },
                            },
                            [_vm._v("通知项目主体")]
                          ),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "twoTitleNav" }, [
                        _c("span", [
                          _vm._v("抽取人员： "),
                          _c("span", [_vm._v(_vm._s(_vm.form.extractorName))]),
                        ]),
                        _c("span", [
                          _vm._v("抽取完成时间： "),
                          _c("span", [_vm._v(_vm._s(_vm.form.extractTime))]),
                        ]),
                      ]),
                    ]),
                  ]),
                  _c(
                    "el-table",
                    {
                      attrs: {
                        data: _vm.resultTableData,
                        stripe: "",
                        "header-cell-style": this.$globalGrayTableHeaderStyle,
                        border: "",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          fixed: "",
                          label: "序号",
                          type: "index",
                          width: "50",
                          align: "center",
                          "show-overflow-tooltip": true,
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "项目名称",
                          prop: "bidSectionName",
                          "header-align": "center",
                          align: "left",
                          "min-width": "200",
                          "show-overflow-tooltip": true,
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "项目编号",
                          prop: "bidSectionCode",
                          width: "200",
                          "header-align": "center",
                          align: "center",
                          "show-overflow-tooltip": true,
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "项目类型",
                          prop: "projectTypeName",
                          "header-align": "center",
                          align: "center",
                          width: "100",
                          "show-overflow-tooltip": true,
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "合同金额（元）",
                          prop: "contractMoney",
                          align: "center",
                          width: "140",
                          "show-overflow-tooltip": true,
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", [
                                  _vm._v(_vm._s(scope.row.contractMoney)),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "招标公告发布时间",
                          prop: "tenderBulletinDate",
                          align: "center",
                          width: "150",
                          "show-overflow-tooltip": true,
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.formatDate(
                                        scope.row.tenderBulletinDate,
                                        "yyyy-MM-dd HH:mm:ss"
                                      )
                                    )
                                  ),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "合同签署时间",
                          prop: "contractSignDate",
                          "header-align": "center",
                          align: "center",
                          width: "150",
                          "show-overflow-tooltip": true,
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.formatDate(
                                        scope.row.contractSignDate,
                                        "yyyy-MM-dd HH:mm:ss"
                                      )
                                    )
                                  ),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "执法检查人员",
                          prop: "executorsIdsName",
                          "header-align": "center",
                          align: "center",
                          "min-width": "200",
                          "show-overflow-tooltip": true,
                        },
                      }),
                      _c("el-table-column", {
                        attrs: { label: "操作", align: "center", width: "230" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text", size: "small" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.routerDetail(
                                          scope.row,
                                          "project"
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("查看项目信息")]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text", size: "small" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.routerDetail(
                                          scope.row,
                                          "result"
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("录入检查结果")]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }